//Le reducer a besoin de 2 éléments pour fonctionner
//1. l'action (l'info sur ce qui se passe
//2. une copie du state actuel

export default function hideage(state = [], action) {
    if (action.type === 'hideAge') {
        if (action.hideAge === true) {
            return { displayValue: 'none' };
        }
        else if (action.hideAge === false) {
            return { displayValue: '' };
        }
    }
    else {
        return state
    }
}
